(function($) {

	'use strict';

	var init = function() {

        obfuscateLinks();

	};

    var obfuscateLinks = function() {

        $('.obfuscate').each(function() {
            $(this).click(function() {
                var data = $(this).data("obfuscate");
                if(data != undefined) {
                    var url = atob(data);
                    var target = $(this).data("target") ? $(this).data("target") : null;
                    if(url != null && url != '' && url != 0) {
                        if(target != null) {
                            window.open(url, target);
                        } else {
                            window.location.replace(url);
                        }
                    }
                }
            });
        });

    }

	$(document).ready(function() {
		init();
	});

})(jQuery);